import Search from "../../../../components/PageView/PageViewTable/Search";

export const getReferenceQuery = (
  searchValue: string = "",
  customField: string = "_RecordName"
) => ({
  Fields: ["id", "_RecordName"],
  Filters: searchValue
    ? [
        {
          Filters: [
            {
              Field: customField,
              Method: "contains",
              Value: searchValue,
            },
          ],
          Group: true,
        },
      ]
    : [],
  OrderBy: {
    Field: "Created",
    Direction: "DESC",
  },
  Pagination: {
    Count: 25,
    Page: 1,
  },
});

const ReferenceSearch = ({
  setQuery,
  searchCustomField,
}: {
  setQuery: (query: any) => void;
  searchCustomField?: string;
}) => {
  return <Search onChange={handleSearch} alwaysOpen block={true} />;

  function handleSearch(filterValue: string) {
    setQuery(
      getReferenceQuery(filterValue, searchCustomField || "_RecordName")
    );
  }
};

export default ReferenceSearch;
